(function () {
  let i, len;

  const container = document.getElementById("site-navigation");

  if (!container) {
    return;
  }

  const button = document.getElementsByClassName("menu-toggle")[0];

  if ("undefined" === typeof button) {
    return;
  }

  const menu = container.getElementsByTagName("ul")[0];

  // Hide menu toggle button if menu is empty and return early.
  if ("undefined" === typeof menu) {
    button.style.display = "none";
    return;
  }

  if (-1 === menu.className.indexOf("nav-menu")) {
    menu.className += " nav-menu";
  }

  const toggleMobileMenu = () => {
    // Get menu item with children.
    const hasChild = container.querySelectorAll(
      "ul.menu > .menu-item-has-children",
    );

    hasChild.forEach(function (child, index) {
      child.getElementsByTagName("a")[0].classList.add("dropdown-toggle");
    });

    const dropdownToggle = container.querySelectorAll(".dropdown-toggle");

    dropdownToggle.forEach(function (toggle, index) {
      toggle.addEventListener("click", toggleSubMenu);

      function toggleSubMenu(event) {
        event.preventDefault();
        toggle.parentNode.classList.toggle("opened");
      }
    });
  };

  toggleMobileMenu();

  // Add this after toggleMobileMenu();
  const mobileOverlay = container.querySelector(".mobile-overlay");

  if (mobileOverlay) {
    mobileOverlay.addEventListener("click", function (event) {
      button.classList.remove("is-active");
      container.classList.remove("active-mobile");
      button.setAttribute("aria-expanded", "false");
    });
  }

  // Hide navigation on outside click.
  document.addEventListener("click", function (event) {
    const isClickInside =
      container.contains(event.target) || button.contains(event.target);

    if (!isClickInside) {
      button.classList.remove("is-active");
      container.className = container.className.replace("active-mobile", "");
      button.setAttribute("aria-expanded", "false");
    }
  });

  // Hide navigation on esc click.
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      button.classList.remove("is-active");
      container.className = container.className.replace("active-mobile", "");
      button.setAttribute("aria-expanded", "false");
    }
  });

  button.onclick = function (event) {
    event.preventDefault();
    if (container.classList.contains("active-mobile") === false) {
      this.classList.add("is-active");
      container.className += " active-mobile";
      button.setAttribute("aria-expanded", "true");
    } else {
      this.classList.remove("is-active");
      container.className = container.className.replace("active-mobile", "");
      button.setAttribute("aria-expanded", "false");
    }
  };
})();
